module.exports = __webpack_public_path__ + "media/knocking_door.874cfbfa.ogg";